var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".portfel_svg__cls-1{fill:none;stroke:#000;stroke-width:1px;stroke-miterlimit:10}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "portfel_svg__icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "portfel_svg__cls-1",
    d: "M19.603 7.534c-1.855-1.63-13.309-1.58-15.206 0-2.183 1.817-1.901 11.029 0 12.604 1.276 1.058 5.193 1.22 7.391 1.22 2.146 0 6.008-.146 7.815-1.22 1.58-.897 2.39-10.505 0-12.604z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "portfel_svg__cls-1",
    d: "M8.282 6.363c-.015-1.39.184-2.817.595-3.215.795-.767 5.563-.767 6.358 0a5.556 5.556 0 01.596 3.069"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000",
    d: "M3.552 11.314h17.052"
  }))));
}
export default SvgPortfel;